import type { Dispatch, FocusEvent, SetStateAction } from 'react';

/** Espacement vertical minimal entre critères, bouton Rechercher et grille (popups renderPanel). */
export const U2000_AUTOCOMPLETE_PANEL_COMPACT = {
  rootGap: 'gap-2',
  criteriaToolbar: 'flex shrink-0 flex-col gap-2',
  criteriaFields: 'flex flex-col gap-2',
  criteriaRow: 'flex items-stretch gap-2',
  searchRow: 'w-full shrink-0',
} as const;

/** Réinitialise la surbrillance grille lorsque le focus revient sur un champ critère du popup. */
export function createPanelCriteriaFocusHandler(setHighlightedIndex: Dispatch<SetStateAction<number>>) {
  return (e: FocusEvent) => {
    const el = e.target as HTMLElement;
    const tag = el.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') {
      setHighlightedIndex(-1);
    }
  };
}
